import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { Product } from '../../../core/models/product-models';
import { BehaviorSubject } from 'rxjs';
import { CatalogueService } from '../../../core/services/catalogue/catalogue.service';
import { CartService } from '../../../core/services/cart/cart.service';
import { ProductModalComponent } from '../product-modal/product-modal.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLabel } from '@angular/material/form-field';
@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, MatButton, MatIcon, MatLabel],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent {
  cartService = inject(CartService);
  totalItem: number = 0;
  isAddedToCart: boolean = false;
  isAddToCart: boolean = true;
  isInCart: boolean = false;
  public products: any[];
  protected router = inject(Router);
  @Input({ required: true }) product!: Product;
  @Input() countryIsoCode!: string;
  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
    this.cartService.getProducts().subscribe(products => {
      this.isInCart = products.some((p: { item_SKU: string; }) => p.item_SKU === this.product.item_SKU);
    });
  }
  onImgError(event: any) {
    event.target.src = 'assets/images/no-image-found.jpg';
  }
  addToCart(item: Product): void {
    this.isAddedToCart = true;
    this.isAddToCart = false
    this.cartService.addProductToCart(item);
    this.isInCart = true;
  }

  cart(): void {
    this.router.navigateByUrl('cart');
  }


  openImageModal(product: any): void {

    this.cartService.getProducts().subscribe(res => {
      this.products = res;
    });
    debugger;
    var isItemInCart=this.products.some(s=>s.item_SKU==product.item_SKU);
    if(isItemInCart)
    {
      this.isAddedToCart=true;
      this.isAddToCart=false;

    }
    const dialogRef = this.dialog.open(ProductModalComponent, {
      data: {
        product: product,
        isAddedToCart: this.isAddedToCart,
        isAddToCart: this.isAddToCart
      },
      minHeight: '500px', // Adjust as needed
      minWidth  : '80vw', // Adjust as needed
      autoFocus: false,
      disableClose: true, // Prevent closing the dialog by clicking outside or pressing escape
      panelClass: 'custom-dialog-container' // Custom class for styling
    });
    const dialogWidth = dialogRef.componentInstance.dialogRef._containerInstance._config.width;
    console.log('Dialog width:', dialogWidth);
  }

}
